import LogCannon from '@ace-clublabs/log-cannon';
import { ICreateManifestRequest } from '@lib/types/';
import axios from 'axios';
import { ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { createAxiosConfig } from '../mockHelper';

export const CreateManifestApi = (endpoint: string) => async (request: ICreateManifestRequest) => {
  try {
    const scenario = CookieHelper.getCookie('scenario');
    LogCannon.blast('CreateManifestApi scenario', { scenario });

    LogCannon.blast('CreateManifestApi start', {
      endpoint,
      membershipNumber: request.membershipNumber,
      zipCode: request.zipCode,
      optedDiscount: request.optedDiscount,
      appFlow: request?.appFlow,
      brokerRegion: request?.brokerRegion,
    });
    const response = await axios.post(`${endpoint}`, request, createAxiosConfig(scenario, endpoint));

    LogCannon.blast('CreateManifestApi success');
    return Promise.resolve(response.data);
  } catch (error: any) {
    LogCannon.error('CreateManifestApi error', { error: error?.message });

    if (error.response) {
      return Promise.reject({
        message: error.response.data?.message,
        requestId: error.response.data?.requestId,
        type: ErrorType.SYSTEM_ERROR,
      });
    } else {
      return Promise.reject({
        message: error,
      });
    }
  }
};
